import {
  assignCoverage,
  cancelCoverage,
  dismissNotification,
  getActiveFiles,
  getClosedFiles,
  getCoveringFiles,
  getCurrentCoverage,
  getInternalUsers,
  getNotifications,
  setCoverageModalClosed,
  setCoverageModalOpen,
  updateCoverage,
} from './myFiles.actions';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getAllEnumerations } from 'modules/enumerations/store/enumerationActions';
import { showToast } from 'modules/layout/layout.actions';
import { withRouter } from 'react-router-dom';
import MyFilesComponent from './myFiles.component';
import React, { Component } from 'react';

const INITIAL_PAGE = 1;
const INITIAL_ROWS_PER_PAGE = 10;

class MyFilesContainer extends Component {
  componentDidMount() {
    if (this.props.userId) {
      this.loadAllData();
    }
  }

  componentDidUpdate(prevProps) {
    const userBecameAvailable = !prevProps.userId && this.props.userId;
    // The dashboard's user selector can change while this tab is mounted
    const selectedUserChanged =
      this.props.selectedUserId && prevProps.selectedUserId !== this.props.selectedUserId;

    if (userBecameAvailable || selectedUserChanged) {
      this.loadAllData();
    }
  }

  loadAllData = () => {
    const { selectedUserId } = this.props;

    if (!this.props.allEnums) {
      this.props.getAllEnumerations();
    }

    this.props.getActiveFiles(selectedUserId);
    this.props.getCoveringFiles(selectedUserId);
    this.props.getClosedFiles(selectedUserId, INITIAL_PAGE, INITIAL_ROWS_PER_PAGE);
    this.props.getCurrentCoverage(selectedUserId);
    this.props.getInternalUsers();
    this.props.getNotifications(selectedUserId, 'CoverageAssigned');
  };

  render() {
    return <MyFilesComponent {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  // User info
  userId: state.auth.profile?.internalUserId,
  userName: state.auth.profile ? `${state.auth.profile.firstName} ${state.auth.profile.lastName}` : '',

  // Files data
  activeFiles: state.myFiles.activeFiles,
  coveringFiles: state.myFiles.coveringFiles,
  closedFiles: state.myFiles.closedFiles,
  closedFilesTotalCount: state.myFiles.closedFilesTotalCount,

  // Coverage data
  currentCoverage: state.myFiles.currentCoverage,
  internalUsers: state.myFiles.internalUsers,

  // Notifications
  notifications: state.myFiles.notifications,

  // Loading states
  isLoadingActiveFiles: state.myFiles.isLoadingActiveFiles,
  isLoadingCoveringFiles: state.myFiles.isLoadingCoveringFiles,
  isLoadingClosedFiles: state.myFiles.isLoadingClosedFiles,
  isLoadingCoverage: state.myFiles.isLoadingCoverage,
  isLoadingUsers: state.myFiles.isLoadingUsers,
  isLoadingNotifications: state.myFiles.isLoadingNotifications,

  // Modal state
  isCoverageModalOpen: state.myFiles.isCoverageModalOpen,
  isEditingCoverage: state.myFiles.isEditingCoverage,
  existingCoverageData: state.myFiles.existingCoverageData,

  // Errors
  error: state.myFiles.error,

  // Enumerations
  allEnums: state.enumerations.allEnums,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    showToast,
    getAllEnumerations,
    getInternalUsers,
    getActiveFiles,
    getCoveringFiles,
    getClosedFiles,
    getCurrentCoverage,
    getNotifications,
    assignCoverage,
    updateCoverage,
    cancelCoverage,
    setCoverageModalOpen,
    setCoverageModalClosed,
    dismissNotification,
  }),
)(MyFilesContainer);
